export function addEvents() {
  throw new Error(
    '@luma.gl/addons: `addEvents` is removed. Use `EventManager` from mjolnir.js instead.'
  );
}
